import { RemoteFinalizeResult } from '../../../data/usecases/finalize-result/remote-finalize-result'
import { makeAxiosHttpClient } from '../../factories/http/axios-http-client-factory'

export const makeFinalizeResult = (cdTeste:string, cdTipoTabela:string, parametro:string, pontuacao:string) => new RemoteFinalizeResult(`/cotacao/finalizeResult?cdTeste=${cdTeste}&cdTipoTabela=${cdTipoTabela}&parametro=${parametro}&pontuacao=${pontuacao}`, makeAxiosHttpClient())
